import { useState, useSyncExternalStore } from 'react';
import { useMutation } from 'react-query';
import { assetsClipRenameClipPartialUpdate, AssetsClipRenameClipPartialUpdateProps } from '@goldcast/api/content';
import { Clip } from '@/domains/asset';

import { updateClipInList, updateClipWithId } from '@/stores/clip';
import { showErrorToast } from '@/libs/toast/toast';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';

export const useClipTitleRename = () => {
  const [renamingClip, setRenamingClip] = useState<Clip | null>(null);
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const closeRenamingClipDialog = () => {
    setRenamingClip(null);
  };
  const { mutate: updateClipTitle } = useMutation(assetsClipRenameClipPartialUpdate, {
    onError: () => showErrorToast("Oops! Couldn't rename the asset. Please try again.")
  });

  const onSaveNewTitle = (newTitle: string) => {
    if (!renamingClip) {
      return;
    }

    if (renamingClip.title !== newTitle) {
      // @kashish TODO - any is used here because Clip and AssetList types are clashing. We should use AssetList instead of Clip everywhere
      updateClipTitle({
        body: {
          asset_id: renamingClip.id,
          title: newTitle
        }
      } as AssetsClipRenameClipPartialUpdateProps);
      const shouldDeleteConfig = featureFlags[FeatureFlagKeys.Use_CL_Delete_Config];
      const assetMetadata = shouldDeleteConfig
        ? renamingClip.asset_metadata
        : {
            ...renamingClip.asset_metadata,
            config: {
              ...((renamingClip.asset_metadata.config ?? {}) as any),
              filename: newTitle
            }
          };
      const updatedClip: Clip = {
        ...renamingClip,
        title: newTitle,
        asset_metadata: assetMetadata
      };
      updateClipWithId(renamingClip.id, updatedClip, false, true);
      updateClipInList(updatedClip);
    }

    closeRenamingClipDialog();
  };

  return {
    renamingClip,
    onSaveNewTitle,
    closeRenamingClipDialog,
    setRenamingClip
  };
};
